export const environment = {
    production: true,
    environmentName: 'Development',
    idleTimeout:   1200, // in seconds (20mins) 
    apiUrl    : 'https://s4tzd9wdj8.execute-api.ap-southeast-1.amazonaws.com/dev',
    webUrl    : 'https://localhost:4200',
};
